<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <div class="tabs-widget">
        <div class="tab-item  active" @click="switchTab('payment')">PAYMENT SETTINGS</div>
        <div class="h-spacer"></div>
        <div class="tab-item" @click="switchTab('announcement')">
          ANNOUNCEMENT
        </div>
        <div class="h-spacer" v-if="false"></div>
        <div class="tab-item" v-if="false" @click="switchTab('static_content')">
          STATIC CONTENT
        </div>
      </div>
      <div class="tab-options">
      </div>
    </div>
    <div class="wrapper-body">
      <b-loading :is-full-page="false" v-model="loadingAllSettings" :can-cancel="false"></b-loading>
      <article class="message">
        <div class="message-header">
          BESOFT PAYMENT SETTINGS
          <b-button type="is-primary" @click="submitBefoftPaymentSettings()" :loading="saveBesoftLoading">SAVE</b-button>
        </div>
        <div class="message-body">
          <div class="settings-form-widget">
            <b-field label="Webhook Url">
              <b-input v-model="besoftForm.callbackUrl.value"></b-input>
            </b-field>

            <b-field label="Webhook secret key">
              <b-input v-model="besoftForm.secretKey.value" type="password" password-reveal></b-input>
            </b-field>

          </div>
        </div>
      </article>
    </div>
    <div class="wrapper-footer"></div>

  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({
    besoftForm: {
      callbackUrl: {
        key: "besoft_callback_url",
        value: "",
      },
      secretKey: {
        key: "besoft_secret_key",
        value: "",
      }
    },
    saveBesoftLoading: false,
    loadingAllSettings: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getAllSettings();
  },
  computed: {},
  methods: {
    submitBefoftPaymentSettings() {
      let vm = this;
      vm.saveBesoftLoading = true;
      vm.$store
        .dispatch("SETTINGS_PAYMENT_BESOFT_UPDATE", {
          settings: [
            vm.besoftForm.callbackUrl,
            vm.besoftForm.secretKey
          ]
        })
        .then((response) => {
          vm.saveBesoftLoading = false;
          vm.getAllSettings();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Message",
            text: response.data.message,
          });
        })
        .catch(({ response }) => {
          vm.saveBesoftLoading = false;
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: response.data.message,
          });
        });
    },
    getAllSettings() {
      let vm = this;
      vm.loadingAllSettings = true;
      vm.$store
        .dispatch("SETTINGS_GET_ALL")
        .then((response) => {
          vm.loadingAllSettings = false;
          response.data.return.forEach(item => {
            if (item.key === vm.besoftForm.callbackUrl.key) {
              vm.besoftForm.callbackUrl.value = item.value;
            }
            if (item.key === vm.besoftForm.secretKey.key) {
              vm.besoftForm.secretKey.value = item.value;
            }
          });
        })
        .catch((error) => {
          vm.loadingAllSettings = false;
        });
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;
      white-space: nowrap;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    display: flex;

    .message {
      width: 100%;
      height: max-content;
    }
  }

}
</style>
